/* MoRetro Studio V27 - Workshop shared config/helpers */
window.MTS = window.MTS || {};

(function(MTS){
  "use strict";

  const DEFAULT_PRINTERS = [
    {id:"ender1", name:"Ender 3 V3 SE #1", brand:"Creality", model:"Ender 3 V3 SE", connectionType:"klipper", port:"7125", active:true},
    {id:"ender2", name:"Ender 3 V3 SE #2", brand:"Creality", model:"Ender 3 V3 SE", connectionType:"klipper", port:"7125", active:true},
    {id:"sidewinder", name:"Sidewinder X4 Plus", brand:"Artillery", model:"Sidewinder X4 Plus", connectionType:"klipper", port:"7125", active:true},
    {id:"kobra", name:"Kobra S1", brand:"Anycubic", model:"Kobra S1", connectionType:"anycubic", port:"", active:true, materialSystem:"ace-pro"},
    {id:"p2s1", name:"P2S #1", brand:"Bambu Lab", model:"P2S", connectionType:"bambu", port:"", active:true, materialSystem:"ams"},
    {id:"p2s2", name:"P2S #2", brand:"Bambu Lab", model:"P2S", connectionType:"bambu", port:"", active:true, materialSystem:"ams"},
    {id:"h2d", name:"H2D", brand:"Bambu Lab", model:"H2D", connectionType:"bambu", port:"", active:true, materialSystem:"ams"}
  ];

  const state = {
    machines: [],
    loaded: false,
    loading: false,
    unsubMachines: null,
    renderTimer: null,
    telemetryPollTimer: null,
    openNetworkPanels: new Set(),
    machineDrafts: new Map(),
    cameraDetections: new Map(),
    cameraDetectionPending: new Set(),
    cameraPopupRefreshTimer: null
  };

  function esc(v){
    return MTS.escapeHtml ? MTS.escapeHtml(v) : String(v ?? "").replace(/[&<>\"']/g, m=>({"&":"&amp;","<":"&lt;",">":"&gt;",'\"':"&quot;","'":"&#039;"}[m]));
  }

  function money(v){
    return MTS.money ? MTS.money(v) : `${Number(v || 0).toFixed(2).replace(".", ",")} EUR`;
  }

  function uidSafe(value){
    return String(value || "")
      .toLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9_-]+/g, "-")
      .replace(/^-+|-+$/g, "") || `machine-${Date.now()}`;
  }

  function nowIso(){ return new Date().toISOString(); }

  function toDate(value){
    try{
      if(!value) return null;
      if(value.toDate) return value.toDate();
      const d = new Date(value);
      return Number.isNaN(d.getTime()) ? null : d;
    }catch(e){ return null; }
  }

  function isoFromAny(value){
    const d = toDate(value);
    return d ? d.toISOString() : (value || "");
  }

  function defaultMachine(machine = {}){
    const id = uidSafe(machine.id || machine.name);
    const host = String(machine.host || machine.localIp || machine.ip || "").trim();
    const type = String(machine.connectionType || machine.type || "other").trim() || "other";

    return {
      id,
      name: machine.name || "Imprimante",
      brand: machine.brand || "",
      model: machine.model || "",
      serial: machine.serial || "",
      firmware: machine.firmware || machine.software || "",
      host,
      ip: machine.ip || machine.localIp || host || "",
      localIp: machine.localIp || machine.ip || host || "",
      tailscaleIp: machine.tailscaleIp || "",
      mac: machine.mac || "",
      port: String(machine.port || ""),
      type,
      connectionType: type,
      materialSystem: machine.materialSystem || "",
      interfaceUrl: machine.interfaceUrl || "",
      webcamUrl: machine.webcamUrl || "",
      cameraRelay: !!machine.cameraRelay,
      cameraRelayUrl: machine.cameraRelayUrl || "",
      cameraStillUrl: machine.cameraStillUrl || "",
      cameraUpdatedAt: isoFromAny(machine.cameraUpdatedAt),
      localCameraUrl: machine.localCameraUrl || "",
      proxyUrl: machine.proxyUrl || "",
      telemetry: machine.telemetry || null,
      online: machine.online,
      state: machine.state || "",
      progress: machine.progress,
      filename: machine.filename || "",
      nozzleTemp: machine.nozzleTemp,
      nozzleTarget: machine.nozzleTarget,
      bedTemp: machine.bedTemp,
      bedTarget: machine.bedTarget,
      message: machine.message || "",
      error: machine.error || "",
      status: machine.status || "free",
      manualStatus: machine.manualStatus || "",
      active: machine.active !== false,
      nozzle: machine.nozzle || "0.4",
      bed: machine.bed || "",
      hours: Number(machine.hours || 0),
      purchasePrice: Number(machine.purchasePrice || 0),
      purchaseDate: machine.purchaseDate || "",
      lastMaintenanceAt: isoFromAny(machine.lastMaintenanceAt),
      lastConnectionStatus: machine.lastConnectionStatus || "unknown",
      lastConnectionAt: isoFromAny(machine.lastConnectionAt),
      lastConnectionMessage: machine.lastConnectionMessage || "",
      connectorStatus: machine.connectorStatus || "unknown",
      connectorId: machine.connectorId || "",
      lastSeenAt: isoFromAny(machine.lastSeenAt),
      createdAt: isoFromAny(machine.createdAt) || nowIso(),
      updatedAt: isoFromAny(machine.updatedAt) || nowIso(),
      ...machine,
      id,
      host,
      localIp: machine.localIp || machine.ip || host || "",
      ip: machine.ip || machine.localIp || host || "",
      type,
      connectionType: type,
      manualStatus: machine.manualStatus || "",
      lastSeenAt: isoFromAny(machine.lastSeenAt),
      updatedAt: isoFromAny(machine.updatedAt) || nowIso()
    };
  }

  MTS.WorkshopConfig = {
    VERSION: "V28.5",
    LOCAL_KEY: "moretroWorkshopMachinesV27",
    LEGACY_LOCAL_KEYS: ["moretroWorkshopMachinesV253"],
    API_BASE: "https://bubbly-vibrancy-production.up.railway.app",
    PRODUCTION_STATUSES: ["paid", "printing", "finishing", "ready"],
    DEFAULT_PRINTERS,
    state,
    h: {esc, money, uidSafe, nowIso, toDate, isoFromAny, defaultMachine}
  };
})(window.MTS);
